import { HTMLComponent } from "@commercekit/react";
import type { ProductAndCategoryDocumentDataCategoriesMobileNavItem } from "prismicio-types";
import WvLink from "../atoms/WvLink";

type WvCategoryQuickMobileNavProps = {
  items: ProductAndCategoryDocumentDataCategoriesMobileNavItem[];
  className?: string;
};
const WvCategoryQuickMobileNav: HTMLComponent<WvCategoryQuickMobileNavProps> = ({ items, className }) => {
  return (
    <div className={["category-quick-mobile-nav", className].filter(Boolean).join(" ")}>
      {items.filter((item) => item.name && item.link).map((item) => (
        <WvLink
          key={`${item.name}-${item.link}`}
          to={item.link!}
          className="item"
        >
          {item.name}
        </WvLink>
      ))}
    </div>
  );
};

export default WvCategoryQuickMobileNav;
